module.exports = __webpack_public_path__ + "static/media/yale.d3a4296a.png";